// ─────────────────────────────────────────────────────────────────────────────
// PATTERNS — what repeats, measured (plan 5.3). Sub-tabs: What Slips · Your
// Best State. Logic: Buckly.dc.html:960-981, :1258-1263; markup: :370-399.
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';
import { sx, TabProps } from './primitives';
import { PAT_INTRO_BEST, PAT_INTRO_SLIPS, bestCards, slipCards } from './placeholders';

type PatternSrc = { title: string; n: string; body: string; fill: number; color: string; source: string; highlight?: string };

export function PatternsTab({ s, set }: TabProps) {
  const patSub = s.patSub;
  const mkCards = (arr: ReadonlyArray<PatternSrc>) => arr.map((c) => ({
    title: c.title, n: c.n, body: c.body, source: c.source, highlight: c.highlight || '',
    hasHighlight: !!c.highlight,
    dotStyle: `flex:none; width:9px; height:9px; border-radius:50%; background:rgb(${c.color}); box-shadow:0 0 8px rgba(${c.color},0.7);`,
    barFill: `height:100%; width:${c.fill}%; border-radius:999px; background:linear-gradient(90deg, rgba(${c.color},0.4), rgba(${c.color},0.95)); box-shadow:0 0 12px rgba(${c.color},0.4);`,
    srcDot: `flex:none; width:6px; height:6px; border-radius:50%; background:rgb(${c.color});`,
  }));
  const v = {
    patternCards: mkCards(patSub === 'slips' ? slipCards : bestCards),
    slipsActive: patSub === 'slips', slipsIdle: patSub !== 'slips',
    bestActive: patSub === 'best', bestIdle: patSub !== 'best',
    patIntro: patSub === 'slips' ? PAT_INTRO_SLIPS : PAT_INTRO_BEST,
    onSlips: () => set({ patSub: 'slips' }),
    onBest: () => set({ patSub: 'best' }),
  };

  return (
    // ⟨design Buckly.dc.html:370-399 — generated by dc2tsx.py; regenerate, never hand-edit⟩
    <div style={sx("padding-top:24px;")}>
      {/* SUB-TAB BAR */}
      <div style={sx("display:flex; align-items:center; gap:10px; margin-bottom:20px; flex-wrap:wrap;")}>
        {v.slipsActive && (
          <button onClick={v.onSlips} style={sx("padding:9px 18px; border-radius:10px; font-family:inherit; font-size:14px; cursor:pointer; background:rgba(60,150,230,0.16); border:1px solid rgba(60,150,230,0.42); color:#6fc0f2; font-weight:600;")}>What slips</button>
        )}
        {v.slipsIdle && (
          <button onClick={v.onSlips} style={sx("padding:9px 18px; border-radius:10px; font-family:inherit; font-size:14px; cursor:pointer; background:rgba(255,255,255,0.02); border:1px solid rgba(255,255,255,0.08); color:rgba(210,220,222,0.6);")}>What slips</button>
        )}
        {v.bestActive && (
          <button onClick={v.onBest} style={sx("padding:9px 18px; border-radius:10px; font-family:inherit; font-size:14px; cursor:pointer; background:rgba(60,150,230,0.16); border:1px solid rgba(60,150,230,0.42); color:#6fc0f2; font-weight:600;")}>Your best state</button>
        )}
        {v.bestIdle && (
          <button onClick={v.onBest} style={sx("padding:9px 18px; border-radius:10px; font-family:inherit; font-size:14px; cursor:pointer; background:rgba(255,255,255,0.02); border:1px solid rgba(255,255,255,0.08); color:rgba(210,220,222,0.6);")}>Your best state</button>
        )}
      </div>
      {/* INTRO */}
      <p style={sx("margin:0 0 20px; font-size:14.5px; line-height:1.6; color:rgba(210,220,222,0.6); max-width:900px;")}>
        {"PATTERN-PULSE computes these deterministically across your trade history — surfaced as measurables with the evidence, never as a label. "}
        <span style={sx("color:#6fc0f2;")}>{v.patIntro}</span>
      </p>
      {/* PATTERN CARDS */}
      <div style={sx("display:flex; flex-direction:column; gap:18px;")}>
        {v.patternCards.map((c, cIdx) => (
          <div key={cIdx} style={sx("padding:24px 26px; border-radius:14px; background:linear-gradient(180deg, rgba(10,16,28,0.7) 0%, rgba(6,9,18,0.8) 100%); border:1px solid rgba(60,150,230,0.18); box-shadow:inset 0 1px 0 rgba(255,255,255,0.04), 0 0 30px rgba(40,110,200,0.04);")}>
            <div style={sx("display:flex; align-items:center; gap:14px; margin-bottom:14px;")}>
              <span style={sx(c.dotStyle)} />
              <span style={sx("flex:1; font-size:19px; font-weight:600; color:#f3f7f8;")}>{c.title}</span>
              <span style={sx("flex:none; font-family:'JetBrains Mono',monospace; font-size:12px; color:#6fc0f2; padding:5px 13px; border-radius:999px; border:1px solid rgba(60,150,230,0.35);")}>{c.n}</span>
            </div>
            <p style={sx("margin:0 0 18px; font-size:14.5px; line-height:1.6; color:rgba(218,226,228,0.74);")}>{c.body}</p>
            <div style={sx("height:7px; border-radius:999px; background:rgba(255,255,255,0.06); overflow:hidden; margin-bottom:18px;")}>
              <div style={sx(c.barFill)} />
            </div>
            <div style={sx("display:flex; align-items:center; gap:9px; font-family:'JetBrains Mono',monospace; font-size:11.5px; color:rgba(200,210,212,0.55);")}>
              <span style={sx(c.srcDot)} />
              {c.source}
            </div>
          </div>
        ))}
      </div>
    </div>
    // ⟨/design⟩
  );
}
